import { bootDate } from "../data/stories";
/* Relative time for freshly published stories; older pieces keep their date */
export const timeAgo = (dateStr) => {
  const then = new Date(dateStr).getTime();
  if (Number.isNaN(then)) return dateStr;
  const mins = Math.round((new Date(bootDate || Date.now()).getTime() - then) / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;
  return dateStr;
};
